import { CommonModule, formatDate, NgClass } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AppIcons } from '../../../../shared/app.icons';
import { AppSettings } from '../../../../shared/app.settings';
import { CommonBindingDataService } from '../../../../shared/services/common-binding-data.service';
import { EntityService } from '../../../../shared/services/entity.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';
import { TimelineModule } from 'primeng/timeline';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { MessageService } from 'primeng/api';
import { MiFormComponent } from 'app/modules/shared/components/mi-form/mi-form.component';
import { PermissionAccessService } from 'app/modules/shared/services/permission-access.service';
import { EntityList } from 'app/modules/shared/models/entity.models';
import { UserManagementService } from 'app/modules/user-management/services/user-management.service';
import { Country } from 'app/modules/shared/models/country';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { TooltipModule } from 'primeng/tooltip';
import { StatusUpdatesComponent } from './components/status-updates/status-updates.component';
import { QuantityProductTableComponent } from './components/quantity-product-table/quantity-product-table.component';
import { OrderInfoComponent } from './components/order-info/order-info.component';
import { NewBackOrderReceivedComponent } from './components/new-back-order-received/new-back-order-received.component';
import * as _ from 'lodash';
import { PatientInfoComponent } from './components/patient-info/patient-info.component';
import { AutoFocusDirective } from 'app/modules/shared/directives/auto-focus.directive';

const ORDER_STATUS = {
  NEW_ORDER: 'NEW_ORDER',
  BACK_ORDER: 'BACK_ORDER',
  RETURN_ORDER: 'RETURN_ORDER',
  ORDER_DISPATCHED: 'Order Dispatched',
  AWAITING_ORDER_RECEIVE_CONFIRMATION: 'AWAITING_ORDER_RECEIVE_CONFIRMATION',
};

const EVENT_STATUS = {
  NEW_ORDER: 'New Order',
  ORDER_DISPATCHED: 'Order Dispatched',
};

@Component({
  selector: 'app-overview-details',
  standalone: true,
  imports: [NewBackOrderReceivedComponent, OrderInfoComponent, ButtonModule, TranslateModule, DropdownModule, ChartModule, OverlayPanelModule, FormsModule, CommonModule,
    NgClass, TableModule, TimelineModule, DialogModule, InputTextModule, ReactiveFormsModule, CalendarModule, InputNumberModule,
    InputTextareaModule, MiFormComponent, TooltipModule, StatusUpdatesComponent, QuantityProductTableComponent, PatientInfoComponent
  ],
  providers: [AutoFocusDirective],
  templateUrl: './overview-details.component.html',
  styleUrl: './overview-details.component.scss'
})

export class OverviewDetailsComponent implements OnInit {
  miIcons = AppIcons;
  iconPos: any = 'right';
  @Output() onToggleOverLay: EventEmitter<boolean> = new EventEmitter();
  fullOrderForm: FormGroup;
  partialOrderForm: FormGroup;
  rejectOrderForm: FormGroup;
  dropDownItems: any[] = [];
  colorStatus;
  selectedItem: any = [];
  data: any;
  options: any;
  tab: any;
  details: any;
  updatedBy: any;
  orderRejectionTimestamp: number = null;
  attributeIdOfOrderId: any;
  latestOrderStatusKey: any;
  attributeIdOfDate: any;
  protocolAttrValue: any;
  entityData: EntityList = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: "",
    actionStatus: "",
  };
  userData: string[] = [];

  partialDateData: any = {
    forTenantCode: this.configService.getForTenantCode(),
    entityCode: AppSettings.ENTITY_CODE.ORDER,
    countryCode: AppSettings.HEADER_COUNTRY_CODE,
    languageCode: "",
    eventCode: "",
    eventId: "",
    data: [],
    relationshipData: [],
    viewCode: "DATE_OF_DISPATCH_VIEW",
  }
  center: google.maps.LatLngLiteral = {
    lat: 24,
    lng: 12,
  };
  zoom = 4;
  map: google.maps.Map;
  bulkRowCount = 1;
  barcodeImage;
  visiblePrintLabel: boolean = false;
  rowData;
  isLoading: boolean = false;
  showDispatchDateCalendar: boolean = false;
  selectedEventId: any;
  eventLat: any;
  eventLng: any;
  marker: any;
  zoneIds: any = [];
  products: any = [];
  orderSummary = [{ name: null, qty: null, isPrice: false }];
  userArray: any = [];
  returnOrderSummary = [{ name: this.cs.getLabel('order.lbl_total_unit'), qty: null, total: null, returning: null }];
  events: any = [];
  showFullOrderDialogBox: boolean = false;
  showPartialOrderDialogBox: boolean = false;
  showStatus: boolean = false;
  showRejectOrderDialogBox: boolean = false;
  orderId: any;
  isDeleted: boolean;
  isUnassigned: boolean;
  country: Country;
  language: any;
  orderDetails: any;
  orderData: any;
  orderDetailId: any;
  attributeLabels: any[];
  attributeValues: any;
  orderProductIds;
  pendingDateOfDispatchModel: Date | null = null;
  deliveryDate: Date | null = null;
  showPartialOrderButton = true;
  dispatchTimestamp;
  partialDispatchTimestamp;
  deliveryProducts: any;
  returnProducts: any;
  isProductReturned: boolean = false;
  confirmReturnForm: FormGroup;
  showConfirmOrderDialog: boolean;
  showReturnOrderDialog: boolean;
  orderStatusColor;
  showPendingDispatchDate: boolean = false;
  rejectionReasonOptions: any[] = [];
  labelData = {
    attributeLabels: [
      { labelKey: 'order.fields.return_proof.label', labelValue: this.cs.getLabel('order.lbl_upload_proof_of_return') },
      { labelKey: 'order.fields.return_proof.validation.required', labelValue: this.cs.getLabel('order.ph_upload_proof_of_return') },
      { labelKey: 'order.fields.return_reason.label', labelValue: this.cs.getLabel('order.lbl_reason_for_return') },
      { labelKey: 'order.fields.return_reason.placeholder', labelValue: this.cs.getLabel('order.lbl_enter_reason') },
      { labelKey: 'order.fields.return_reason.validation.required', labelValue: this.cs.getLabel('order.lbl_reason_for_return_required') },
      { labelKey: 'order.fields.rejection_reason_type.label', labelValue: this.cs.getLabel('order.lbl_rejection_reason_type') },
      { labelKey: 'order.fields.rejection_reason_type.placeholder', labelValue: this.cs.getLabel('order.lbl_select_rejection_reason_type') },
      { labelKey: 'order.fields.rejection_reason_type.validation.required', labelValue: this.cs.getLabel('order.lbl_rejection_reason_type_required') },
      { labelKey: 'order.fields.return_reason.validation.max', labelValue: this.cs.getLabel('order.lbl_reason_for_return_max') },
      { labelKey: 'order.fields.return_reason.validation.min', labelValue: this.cs.getLabel('order.lbl_reason_for_return_min') }
    ]
  };
  dialogAttrLabels: Record<string, string> = {};
  confirmAttributeData: any;
  today = new Date();
  isStatusUpdate: any;
  orderStatus: string;
  createdBy;
  isChildOrder: boolean = false;
  minDate: Date = new Date();
  expectedDispatchMinDate: Date = new Date();
  partialExpectedDispatchMinDate: Date = new Date();
  attributeIdOfBatch;
  acceptPreset;
  batchData: any[] = [];
  returnBatchData: any[] = [];
  shouldShowProductDetails;
  totalUnits: number = 0;
  ORDER_STATUS = ORDER_STATUS;
  EVENT_STATUS = EVENT_STATUS;
  confirmedBatches: any[] = [];
  returnedBatches: any[] = [];
  isPatientManagmentOn: boolean = false;
  protocolEntityId: any;
  showPatientDialog: boolean = false;
  selectedPatientCodes: string[] = [];
  isFirstTimeDialogOpen: boolean = true;
  isFirstTimePartialDialogOpen: boolean = true;
  isOrderSplit: boolean = false;
  isConfirmOrderInProgress: boolean = false;

  constructor(public entityService: EntityService,
    private route: ActivatedRoute,
    public cs: CommonBindingDataService,
    private fb: FormBuilder,
    public configService: ConfigService,
    private messageService: MessageService,
    private permissionAccessService: PermissionAccessService,
    private userService: UserManagementService,
    public metaDataService: MetaDataService,
    private router: Router
  ) { }

  ngOnInit() {
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.route.queryParams.subscribe(params => {
      this.orderId = params.id;
      this.getAttributeOrderIdData().then(() => {
        this.getOrderDetails();
      });
    });
    this.getAttributeBatchData();
    this.isStatusUpdate = this.permissionAccessService.hasAccess('ORDERS', '', 'ALL', 'STATUS_UPDATE');
    this.getAttributeData();
    this.getPartialDate();
    this.fullOrderForm = this.fb.group({
      dispatchDate: ['', Validators.required],
      expectedDispatchDate: ['', Validators.required],
    });



    this.fullOrderForm.get('dispatchDate').valueChanges.subscribe(value => {
      if (value) {
        this.expectedDispatchMinDate = new Date(value);
        const expectedDispatchDateControl = this.fullOrderForm.get('expectedDispatchDate');
        if (expectedDispatchDateControl.value && new Date(expectedDispatchDateControl.value) < this.expectedDispatchMinDate) {
          expectedDispatchDateControl.setValue(null);
        }
      }
    });

    this.partialOrderForm = this.fb.group({
      dispatchDateInStockProduct: ['', Validators.required],
      dispatchDateRemainingProduct: ['', Validators.required],
      expectedDispatchDate: ['', Validators.required],
      availableProductQty: this.fb.array([])
    }, {
      validators: [
        this.dispatchDatesValidator(),
        this.atLeastOneProductQtyValidator()
      ]
    });

    setTimeout(() => {
      this.partialOrderForm.markAsPristine();
    }, 100);

    this.partialOrderForm.get('dispatchDateInStockProduct').valueChanges.subscribe(value => {
      if (value) {
        this.partialExpectedDispatchMinDate = new Date(value);
        const expectedDispatchDateControl = this.partialOrderForm.get('expectedDispatchDate');
        if (expectedDispatchDateControl.value && new Date(expectedDispatchDateControl.value) < this.partialExpectedDispatchMinDate) {
          expectedDispatchDateControl.setValue(null);
        }
      }
    });

    this.rejectOrderForm = this.fb.group({
      reason: ['', [Validators.required, Validators.maxLength(500)]]
    });
  }

  initEntityPayload(orderStatus: string, orderId: string, dateOfDispatch?: string, rejectReason?: string, expectedDispatchDate?: string, isOrderSplit?: boolean) {
    return {
      forTenantCode: this.configService.getForTenantCode(),
      countryCode: AppSettings.HEADER_COUNTRY_CODE,
      orderStatus,
      orderId,
      dateOfDispatch,
      confirmOrderDto: [],
      rejectReason,
      pendingDateOfDispatch: "",
      expectedDeliveryDate: expectedDispatchDate,
      splitOrder: isOrderSplit,
      orderUnitCosts: {}
    }
  }

  getAttributeData() {
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.entityService.getAttributeDefinition(AppSettings.ENTITY_CODE.ORDER, AppSettings.VIEW_CODE.DETAIL_VIEW).subscribe(res => {
      res.tabs.forEach(element => {
        element.groups.forEach(group => {
          if (group.code === 'details') {
            group.entityRelationshipConfigId = null;
          }
        });
      });
      this.attributeLabels = this.cs.getAttributeLabels(res);
      this.orderData = this.cs.getOrganizedAttribute(res);
      if (this.orderData && this.orderData.tabs) {
        this.tab = this.orderData.tabs.find(ele => ele.tabCode === 'overview');
      }
      if (this.tab && this.tab.groups) {
        this.details = this.tab.groups.find(ele => ele.code === 'details');

      }
    })
  }

  getAttributeOrderIdData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
      this.entityService.getAttributeDefinition(AppSettings.ENTITY_CODE.ORDER_ACTIVITY, AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW)
        .subscribe(filterResponse => {
          this.attributeIdOfOrderId = filterResponse.tabs[0].groups[0].fields.find(element => element.attributeCode === 'order_id')?.attributeId;
          resolve();
        }, err => reject(err));
    });
  }

  getOrderDetails() {
    this.entityService.getEntity(this.orderId, AppSettings.ENTITY_CODE.ORDER, AppSettings.VIEW_CODE.DETAIL_VIEW).subscribe((result: any) => {
      this.attributeValues = this.cs.getOrgAttributeValues(result);
      const protocolData = result.relatedData?.find(item => item.entityCode === 'protocol');
      if (protocolData) {
        const protocolNameAttr = protocolData.attributeCodeValueDtoList.find(attr => attr.attributeCode === 'protocol_name');
        this.protocolAttrValue = protocolNameAttr?.attributeValue;
        this.protocolEntityId = protocolData.entityId;

        if (this.configService.isSiteUser()) {
          this.entityService.getProtocolUser(this.protocolEntityId).subscribe((res: any) => {
            this.isPatientManagmentOn = res?.canManagePatient || false;
          });
        }
      }
      const createdValue = result.attributeCodeValueDtoList.find(attr => attr.attributeCode === 'created_by');
      this.createdBy = createdValue.attributeValue;
      const childOrderAttr = result.attributeCodeValueDtoList.find(attr => attr.attributeCode === 'child_order');
      if (childOrderAttr?.attributeValue?.Yes === 'Yes') {
        this.showPartialOrderButton = true;
      } else {
        this.showPartialOrderButton = true;
      }
      const isChildOrder = childOrderAttr?.attributeValue?.Yes === 'Yes';
      this.isChildOrder = isChildOrder;
      const orderStatus = result.attributeCodeValueDtoList.find(attr => attr.attributeCode === 'order_status')?.attributeValue;
      this.orderStatus = Object.keys(orderStatus)[0];
      this.orderStatusColor = this.getOrderStatusColor(this.orderStatus);
      const orderStatusKey = orderStatus ? Object.keys(orderStatus)[0] : '--';
      this.shouldShowProductDetails = ['ORDER_COMPLETED', 'ORDER_PARTIALLY_RECEIVED', 'DELIVERY_COMPLETED'].includes(orderStatusKey);
      const orderStatusValue = orderStatus ? Object.values(orderStatus)[0] : '--';
      this.showDispatchDateCalendar = isChildOrder && (orderStatusKey === 'NEW_ORDER' || orderStatusKey === 'BACK_ORDER' || orderStatusKey === 'RETURN_ORDER') && this.configService.isAdmin();
      this.attributeValues.order_status = orderStatusValue;

      const expectedDeliveryDateAttr = result.attributeCodeValueDtoList.find(attr => attr.attributeCode === 'expected_delivery_date');
      const deliveryTimestamp = expectedDeliveryDateAttr?.attributeValue;
      if (deliveryTimestamp) {
        this.deliveryDate = new Date(Number(deliveryTimestamp));
      }

      if ((orderStatusKey === 'NEW_ORDER' || orderStatusKey === 'BACK_ORDER' || orderStatusKey === 'RETURN_ORDER') && isChildOrder) {
        const dispatchDateAttr = result.attributeCodeValueDtoList.find(attr => attr.attributeCode === 'date_of_dispatch');
        const dispatchTimestamp = dispatchDateAttr?.attributeValue;
        if (dispatchTimestamp) {
          this.pendingDateOfDispatchModel = new Date(Number(dispatchTimestamp));
        }
      }

      if (orderStatusKey === 'ORDER_PARTIALLY_CONFIRMED') {
        const dispatchDateAttr = result.attributeCodeValueDtoList.find(attr => attr.attributeCode === 'date_of_dispatch');
        const dispatchTimestamp = dispatchDateAttr?.attributeValue;

        if (dispatchTimestamp) {
          const parsedDate = new Date(Number(dispatchTimestamp));
          this.pendingDateOfDispatchModel = parsedDate;
          this.showPendingDispatchDate = true;
        }
      }
      this.getUsers();
      this.attributeValues.created_by_role = this.attributeValues.created_by_role.split('_').join(' ');
      this.setOrderSummary(this.attributeValues);
      this.searchEntity(this.orderId, orderStatus);
      this.searchEntityForBatch();
      this.orderProductIds = result.relatedData?.filter((ele: any) => ele.entityCode === 'order_product').map((ele: any) => ele.entityId);

      this.products = result.relatedData.filter(ele => ele.entityCode === 'order_product').map(ele => {
        return {
          name: ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'product_name')?.attributeValue,
          qty: ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'quantity')?.attributeValue,
          remaining: ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'quantity')?.attributeValue,
          price: ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'price')?.attributeValue,
          unitCost: ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'unit_cost')?.attributeValue,
          tempUnitCost: ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'unit_cost')?.attributeValue,
          total: ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'total')?.attributeValue,
          patientIds: ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'patient_ids')?.attributeValue,
          productId: ele.entityId,
          patientCodes: []
        }
      });
      this.getPatientCodeByIds();
      this.buildProductFormArray();
      this.orderDetails = result;
      this.isDeleted = this.getDeleted();
      this.isUnassigned = this.getUnassigned();
      this.showStatus = true;
      this.setupForDeliveryConfirmation();
    })
  }

  getPatientCodeByIds() {
    const allPatientIds = new Set<string>();

    this.products.forEach(product => {
      if (product?.patientIds && Array.isArray(product.patientIds)) {
        product.patientIds.forEach(id => allPatientIds.add(id));
      }
    });
    if (allPatientIds.size === 0) {
      return;
    }

    const requestBody = {
      forTenantCode: this.configService.getForTenantCode(),
      countryCode: AppSettings.HEADER_COUNTRY_CODE,
      viewCode: AppSettings.VIEW_CODE.PATIENT_DETAIL_ON_ORDER_VIEW,
      entityIds: Array.from(allPatientIds),
      limit: 500,
      offset: 0,
      eventCode: 'e001'
    };

    this.entityService.selectedEntityListInBulk(requestBody, AppSettings.ENTITY_CODE.PROTOCOL_PATIENT, true).subscribe((res: any) => {
      const patientIdToCodeMap = new Map<string, string>();
      res.data.forEach(item => {
        patientIdToCodeMap.set(item.id, item.values.patient_id);
      });

      this.products.forEach(product => {
        if (product?.patientIds && Array.isArray(product.patientIds)) {
          product.patientIds.forEach(patientId => {
            const patientCode = patientIdToCodeMap.get(patientId);
            if (patientCode) {
              product.patientCodes.push(patientCode);
            }
          });
        }
      });
    });
  }

  getAttributeBatchData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
      this.entityService.getAttributeDefinition(AppSettings.ENTITY_CODE.ORDER_ACCEPTANCE, AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW)
        .subscribe(filterResponse => {
          this.rejectionReasonOptions = filterResponse.tabs[0].groups[0].fields.find(ele => ele.attributeCode === 'rejection_reason_type')?.presetValues;
          const attributeField = filterResponse.tabs[0].groups[0].fields.find(
            element => element.attributeCode === 'acceptance_status'
          );
          this.attributeIdOfBatch = attributeField.attributeId;
          const presetVal = attributeField.presetValues?.find(p => p.labelKey === 'Accept');
          this.acceptPreset = presetVal?.labelKey;
          resolve();
        }, err => reject(err));
    });
  }

  getOrderStatusColor(status) {
    const statusColors = {
      'NEW_ORDER': '#A01C6B',
      'ORDER_CONFIRMED': '#D9F0EB',
      'ORDER_PARTIALLY_CONFIRMED': '#D9F0EB',
      'ORDER_DISPATCHED': '#D9F0EB',
      'ORDER_COMPLETED': '#65C9BB',
      'DELIVERY_COMPLETED': '#F1DDE9',
      'ORDER_CANCELLED': '#FFB2B2',
      'ORDER_REJECTED': '#FFB2B2',
      'ORDER_RECEIVED': '#F1DDE9',
      'ORDER_PARTIALLY_RECEIVED': '#F1DDE9',
      'BACK_ORDER': '#FFF2D9',
      'RETURN_ORDER': '#FFD9D9',
      'AWAITING_ORDER_RECEIVE_CONFIRMATION': '#D9F4FF',
    };

    return statusColors[status] || 'transparent';
  }

  getDisplayOrderStatus(status: string): string {
    if (!this.configService.isSiteUser() || !status) {
      return status;
    }

    const siteStatusMap: Record<string, string> = {
      'New Order': 'Order Submitted',
      'Order Received': 'Order Delivered',
    };

    return siteStatusMap[status] ?? status;
  }

  openFullOrderDialog(): void {
    this.showFullOrderDialogBox = true;
    this.isFirstTimeDialogOpen = true;

    this.fullOrderForm.reset();
    this.fullOrderForm.markAsPristine();
    this.fullOrderForm.markAsUntouched();

    if (this.isChildOrder && this.pendingDateOfDispatchModel) {
      this.fullOrderForm.patchValue({
        dispatchDate: this.pendingDateOfDispatchModel
      });
    }

    // Initialize tempUnitCost with current unitCost values
    if (Array.isArray(this.products)) {
      this.products.forEach(product => {
        product.tempUnitCost = product.unitCost;
      });
    }

    setTimeout(() => {
      this.isFirstTimeDialogOpen = false;
      const hiddenInput = document.querySelector('#hiddenInputFull') as HTMLInputElement;
      if (hiddenInput) {
        hiddenInput.focus();
      }
    }, 100);
  }

  openPartialOrderDialog(): void {
    this.showPartialOrderDialogBox = true;
    this.isFirstTimePartialDialogOpen = true;
    this.isOrderSplit = false;

    this.partialOrderForm.markAsPristine();
    this.partialOrderForm.markAsUntouched();
    this.buildProductFormArray();

    // Initialize tempUnitCost with current unitCost values for partial flow
    if (Array.isArray(this.products)) {
      this.products.forEach(product => {
        product.tempUnitCost = product.unitCost;
      });
    }

    setTimeout(() => {
      this.isFirstTimePartialDialogOpen = false;
      const hiddenInput = document.querySelector('#hiddenInputPartial') as HTMLInputElement;
      if (hiddenInput) {
        hiddenInput.focus();
      }
    }, 100);
  }


  onAddNewBatch(product) {
    if (!product.confirmBatches) {
      product.confirmBatches = [];
    }
    product.confirmBatches.push({
      confirmQty: '',
      confirmBatch: '',
      confirmExpDate: '',
      returnQty: 0,
      returnBatch: '',
      returnExpDate: '',
      showReturn: false
    });
  }

  onAddNewReturnBatch(product) {
    if (!product.returnBatches) {
      product.returnBatches = [];
    }
    product.returnBatches.push({
      confirmQty: 0,
      confirmBatch: '',
      confirmExpDate: '',
      returnQty: null,
      returnBatch: '',
      returnExpDate: '',
      returnReason: '',
      returnReasonType: '',
      returnQtyError: false,
      showReturn: true
    });

    this.isProductReturned = this.deliveryProducts.some(ele => ele.returnBatches.length > 0);
  }

  getUsers() {
    this.userData = [this.createdBy];
    this.userService.getDetails(this.userData).subscribe((res: any) => {
      if (res && res.length > 0) {
        const user = res[0];
        const fullName = `${user.firstName} ${user.lastName}`;
        this.attributeValues.created_by = fullName;
      }
    });
  }

  setOrderSummaryForReturn() {
    if (this.returnProducts?.length > 0) {
      this.returnOrderSummary = [
        {
          name: this.cs.getLabel('order.lbl_total_units'),
          qty: this.returnProducts.reduce((acc, product) => acc + product.qty, 0),
          total: this.returnProducts.reduce((acc, product) => acc + product.total, 0),
          returning: this.returnProducts.reduce((acc, product) => acc + product.qty, 0)
        }
      ];
    }
  }

  setOrderSummary(attrValue) {
    if (this.configService.isSiteUser()) {
      this.orderSummary = [
        {
          name: this.cs.getLabel('order.lbl_total_units'),
          qty: attrValue.total_units,
          isPrice: false
        }
      ];
    } else {
      this.orderSummary = [
        {
          name: this.cs.getLabel('order.lbl_total_units'),
          qty: attrValue.total_units,
          isPrice: false
        },
        {
          name: this.cs.getLabel('order.lbl_sub_total'),
          qty: attrValue.sub_total_amount,
          isPrice: true
        },
        {
          name: this.cs.getLabel('order.lbl_gst'),
          qty: attrValue.gst_amount,
          isPrice: true
        },
        {
          name: this.cs.getLabel('order.lbl_total_order'),
          qty: attrValue.total_amount,
          isPrice: true
        }
      ];
    }
  }

  searchEntity(orderId, orderStatus) {
    let orderStatusKey = typeof orderStatus === 'object' && orderStatus !== null ? Object.keys(orderStatus)[0] : null;
    this.latestOrderStatusKey = orderStatusKey;
    this.entityData.filters = [{ attributeId: this.attributeIdOfOrderId, attributeValue: [orderId] }];
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    this.entityData.countryCode = AppSettings.HEADER_COUNTRY_CODE;
    this.entityService.searchEntity(AppSettings.ENTITY_CODE.ORDER_ACTIVITY, this.entityData, false).subscribe((res: any) => {
      const rejectedActivity = res.data.find(item => {
        const statusKey = Object.keys(item.values.order_status || {})[0];
        return statusKey === 'ORDER_REJECTED';
      });
      if (rejectedActivity) {
        this.updatedBy = rejectedActivity.values.updated_by;
      }
      const sortedData = res.data.sort((a, b) => a.values.entity_created_at - b.values.entity_created_at);
      if (orderStatusKey === 'BACK_ORDER' || orderStatusKey === 'RETURN_ORDER') {
        orderStatusKey = 'NEW_ORDER'
      }

      if (orderStatusKey === 'AWAITING_ORDER_RECEIVE_CONFIRMATION') {
        orderStatusKey = 'ORDER_DISPATCHED';
      }
      const matchedIndex = sortedData.findIndex(item => Object.keys(item.values.order_status)[0] === orderStatusKey);
      this.events = sortedData.map((item, index) => {
        let statusType;
        if (matchedIndex === -1) {
          statusType = AppSettings.ORDER_DETAILS_CODE.UPCOMING;
        } else if (matchedIndex > index) {
          statusType = AppSettings.ORDER_DETAILS_CODE.DONE;
        } else if (matchedIndex === index) {
          statusType = AppSettings.ORDER_DETAILS_CODE.IN_PROGRESS;
        } else {
          statusType = AppSettings.ORDER_DETAILS_CODE.UPCOMING;
        }
        return {
          status: Object.values(item.values.order_status)[0],
          index,
          statusType,
          createdAt: item.values.entity_created_at
        }
      });
      this.setUpcomingStatus(this.events, orderStatusKey);
    })
  }

  searchEntityForBatch() {
    this.entityData.filters = [{ attributeId: this.attributeIdOfOrderId, attributeValue: [this.orderId] }]
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    this.entityData.countryCode = AppSettings.HEADER_COUNTRY_CODE;
    this.entityService.searchEntity(AppSettings.ENTITY_CODE.ORDER_ACCEPTANCE, this.entityData, false).subscribe((res: any) => {
      this.batchData = res.data;
      this.returnBatchData = res.data.filter(item => item.values.acceptance_status && 'Return' in item.values.acceptance_status);


      this.deliveryProducts.forEach(product => {
        const isAcceptedItem = (item: any) =>
          item.values.order_product_id === product.productId &&
          item.values.acceptance_status &&
          'Accept' in item.values.acceptance_status;

        const acceptedItem = this.batchData.filter(isAcceptedItem);
        product.item = acceptedItem;
      });


      this.setReturnBatchData(this.returnBatchData);

    })


  }


  setReturnBatchData(data: any[]) {
    this.returnBatchData = data;
    this.returnProducts = [];
    const dData = _.cloneDeep(this.deliveryProducts);
    dData.forEach(product => {
      const isReturnedItem = (item: any) =>
        item.values.order_product_id === product.productId &&
        item.values.acceptance_status &&
        'Return' in item.values.acceptance_status;
      product.qty = 0;
      const returnedItem = this.returnBatchData.filter(isReturnedItem);

      returnedItem.forEach(item => {
        product.qty = product.qty + item.values.quantity;
      })
      if (returnedItem.length > 0) {
        // product.qty = product.qty + returnedItem[0].values.quantity;

        this.returnProducts.push({ ...product, item: returnedItem });
      }
    });
    this.setOrderSummaryForReturn();
  }

  getOriginalQuantity(item: any): number {
    return item?.values?.quantity ?? '--';
  }

  getBatchNumber(item: any): string {
    return item?.values?.batch_number ?? '--';
  }

  getFormattedDate(item: any): string {
    const rawDate = item?.values?.expiry_date;
    if (!rawDate) return '--';
    const [day, month, year] = rawDate.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'long', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options);
  }

  setUpcomingStatus(events, orderStatusKey) {
    const happyFlowStatus = [...AppSettings.ORDER_STATUS_HAPPY_FLOW];
    const matchedIndex = happyFlowStatus.findIndex(ele => ele.labelKeys.includes(orderStatusKey));
    if (matchedIndex !== -1) {
      const arrToPush = happyFlowStatus.splice(matchedIndex + 1);
      arrToPush.forEach(ele => {
        this.events.push({
          status: ele.labelValue,
          index: ele.index,
          statusType: AppSettings.ORDER_DETAILS_CODE.UPCOMING,
        })
      })
    }
  }

  showPrintLabelDialog() {
    this.visiblePrintLabel = true;
  }

  onConfirmFullOrder() {
    this.fullOrderForm.markAllAsTouched();
    if (!this.fullOrderForm.valid) {
      this.scrollToFirstInvalidControl();
      return;
    }

    // Validate unit costs
    const invalidUnitCosts = this.products.some(product => !product.tempUnitCost || product.tempUnitCost < 1);
    if (invalidUnitCosts) {
      this.messageService.add({
        key: 'tst',
        severity: 'error',
        summary: 'Error',
        detail: this.cs.getLabel('order.lbl_unit_cost_required')
      });
      this.showFullOrderDialogBox = true;
      this.scrollToFirstInvalidControl();
      return;
    }

    this.showFullOrderDialogBox = false;
    this.isFirstTimeDialogOpen = false;
    if (this.fullOrderForm.valid) {
      const dateRaw = this.fullOrderForm.get('dispatchDate')?.value;
      const expectedDateRaw = this.fullOrderForm.get('expectedDispatchDate')?.value;
      const dispatchDateObj = new Date(dateRaw);
      const expecedDateObj = new Date(expectedDateRaw);
      const dateOfDispatch = new Date(
        Date.UTC(dispatchDateObj.getFullYear(), dispatchDateObj.getMonth(), dispatchDateObj.getDate())
      ).getTime().toString();

      const expectedDateOfDispatch = new Date(
        Date.UTC(expecedDateObj.getFullYear(), expecedDateObj.getMonth(), expecedDateObj.getDate())
      ).getTime().toString();

      const payload = this.initEntityPayload("ORDER_CONFIRMED", this.orderId, dateOfDispatch, '', expectedDateOfDispatch);

      // Add orderUnitCosts to payload
      const orderUnitCosts = {} as Record<string, number>;
      this.products.forEach(product => {
        orderUnitCosts[product.productId] = product.tempUnitCost;
      });
      payload.orderUnitCosts = orderUnitCosts;

      this.entityService.statusOrder(payload, false).subscribe(() => {
        this.dispatchTimestamp = dateOfDispatch;
        this.messageService.add({
          key: 'tst',
          severity: 'success',
          summary: 'Success',
          detail: this.cs.getLabel('order.lbl_confirm_order')
        });
        this.showFullOrderDialogBox = false;
        this.getOrderDetails();
        this.router.navigate(['app/orders'], { queryParams: { status: 'all' } });
      })
    }
  }

  onConfirmPartialOrder() {
    if (this.partialOrderForm.invalid) {
      this.partialOrderForm.markAllAsTouched();

      if (this.partialOrderForm.errors?.noPositiveQty) {
        this.messageService.add({
          key: 'tst',
          severity: 'error',
          summary: 'Error',
          detail: this.cs.getLabel('lbl_order_zero_error_msg')
        });
      }

      this.scrollToFirstInvalidControl();
      this.showPartialOrderDialogBox = true;
      return;
    }

    // Validate unit costs in partial flow
    const invalidUnitCosts = this.products.some(product => !product.tempUnitCost || product.tempUnitCost < 1);
    if (invalidUnitCosts) {
      this.messageService.add({
        key: 'tst',
        severity: 'error',
        summary: 'Error',
        detail: this.cs.getLabel('order.lbl_unit_cost_required')
      });
      this.showPartialOrderDialogBox = true;
      return;
    }

    if (this.isOrderSplit) {
      const formArray = this.partialOrderForm.get('availableProductQty') as FormArray;
      const hasInvalidDispatchDates = formArray.controls.some((control, index) => {
        const dispatchDateControl = control.get('dispatchDate');
        const inStockControl = control.get('inStock');

        // Calculate remaining quantity dynamically to ensure accuracy
        const inStock = Number(inStockControl?.value) || 0;
        const totalQty = Number(this.products[index].qty) || 0;
        const remaining = totalQty - inStock;

        // Only validate dispatch date if remaining quantity > 0
        return remaining > 0 && dispatchDateControl && dispatchDateControl.invalid;
      });

      if (hasInvalidDispatchDates) {
        this.messageService.add({
          key: 'tst',
          severity: 'error',
          summary: 'Error',
          detail: this.cs.getLabel('lbl_dispatch_date_required')
        });
        this.scrollToFirstInvalidControl();
        this.showPartialOrderDialogBox = true;
        return;
      }
    }

    this.showPartialOrderDialogBox = false;
    if (this.partialOrderForm.valid) {
      const dateOfDispatchRaw = this.partialOrderForm.get('dispatchDateInStockProduct')?.value;
      const pendingDateOfDispatchRaw = this.partialOrderForm.get('dispatchDateRemainingProduct')?.value;
      const partialExpectedDateRaw = this.partialOrderForm.get('expectedDispatchDate')?.value;
      const partialExpecedDateObj = new Date(partialExpectedDateRaw);

      const expectedPartialDateOfDispatch = new Date(
        Date.UTC(partialExpecedDateObj.getFullYear(), partialExpecedDateObj.getMonth(), partialExpecedDateObj.getDate())
      ).getTime().toString();

      const dateOfDispatch = dateOfDispatchRaw ? new Date(Date.UTC(new Date(dateOfDispatchRaw).getFullYear(), new Date(dateOfDispatchRaw).getMonth(),
        new Date(dateOfDispatchRaw).getDate())).getTime().toString() : '';

      const pendingDateOfDispatch = pendingDateOfDispatchRaw ? new Date(Date.UTC(new Date(pendingDateOfDispatchRaw).getFullYear(), new Date(pendingDateOfDispatchRaw).getMonth(),
        new Date(pendingDateOfDispatchRaw).getDate())).getTime().toString() : '';


      const payload = this.initEntityPayload('ORDER_PARTIALLY_CONFIRMED', this.orderId, dateOfDispatch, '', expectedPartialDateOfDispatch, this.isOrderSplit);
      payload.pendingDateOfDispatch = pendingDateOfDispatch;

      payload.confirmOrderDto = (this.partialOrderForm.get('availableProductQty') as FormArray).controls.map((control, index) => {
        const confirmOrderItem: any = {
          orderProductId: this.orderProductIds[index],
          quantityInStock: control.get('inStock')?.value
        };

        if (this.isOrderSplit && control.get('dispatchDate')?.value) {
          const dispatchDateRaw = control.get('dispatchDate')?.value;
          const dispatchDate = new Date(Date.UTC(
            new Date(dispatchDateRaw).getFullYear(),
            new Date(dispatchDateRaw).getMonth(),
            new Date(dispatchDateRaw).getDate()
          )).getTime().toString();
          confirmOrderItem.pendingDateOfDispatch = dispatchDate;
        }

        return confirmOrderItem;
      });

      // Add orderUnitCosts to payload for partial flow
      const orderUnitCosts = {} as Record<string, number>;
      this.products.forEach(product => {
        orderUnitCosts[product.productId] = product.tempUnitCost;
      });
      payload.orderUnitCosts = orderUnitCosts;

      this.entityService.statusOrder(payload, false).subscribe(() => {
        this.partialDispatchTimestamp = dateOfDispatch;
        this.messageService.add({
          key: 'tst',
          severity: 'success',
          summary: 'Success',
          detail: this.cs.getLabel('order.lbl_partial_order_confirmed')
        });

        if (pendingDateOfDispatch) {
          this.pendingDateOfDispatchModel = new Date(parseInt(pendingDateOfDispatch));
          this.showPendingDispatchDate = true;
        }
        this.showPartialOrderDialogBox = false;
        this.isFirstTimePartialDialogOpen = false;
        this.showPartialOrderButton = false;
        this.getOrderDetails();
        this.router.navigate(['app/orders'], { queryParams: { status: 'all' } });
      });

    }
  }

  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  scrollToFirstInvalidControl(): void {
    const firstInvalidElement = document.querySelector(
      '.ng-invalid[formControlName], .ng-invalid[formControl]'
    );

    if (firstInvalidElement) {
      this.scrollTo(firstInvalidElement as HTMLElement);
      return;
    }

    // Check partial order product in-stock controls
    const formArray = this.partialOrderForm.get('availableProductQty') as FormArray;
    for (let i = 0; i < formArray.controls.length; i++) {
      const control = formArray.controls[i].get('inStock');
      if (control?.invalid) {
        const el = document.getElementById(`product-in-stock-${i}`);
        if (el) {
          this.scrollTo(el);
          return;
        }
      }
    }

    // Check full order form specific controls
    if (this.fullOrderForm?.invalid) {
      const dispatchEl = document.querySelector('[formControlName="dispatchDate"]');
      if (dispatchEl) {
        this.scrollTo(dispatchEl as HTMLElement);
        return;
      }
      const expectedEl = document.querySelector('[formControlName="expectedDispatchDate"]');
      if (expectedEl) {
        this.scrollTo(expectedEl as HTMLElement);
      }
    }
  }

  dispatchDatesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const inStockDate = control.get('dispatchDateInStockProduct')?.value;
      const remainingDate = control.get('dispatchDateRemainingProduct')?.value;

      if (inStockDate && remainingDate) {
        const inStockTimestamp = new Date(inStockDate).getTime();
        const remainingTimestamp = new Date(remainingDate).getTime();

        if (remainingTimestamp < inStockTimestamp) {
          return { dispatchDateMismatch: true };
        }
      }

      return null;
    };
  }

  atLeastOneProductQtyValidator(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
      const formArray = form.get('availableProductQty') as FormArray;
      if (!formArray || !formArray.controls.length) return null;

      const hasPositiveQty = formArray.controls.some(control => {
        const value = Number(control.get('inStock')?.value || 0);
        return value > 0;
      });

      return hasPositiveQty ? null : { noPositiveQty: true };
    };
  }

  onStockUpdate(index: number) {
    const formArray = this.partialOrderForm.get('availableProductQty') as FormArray;
    const control = formArray.at(index).get('inStock');
    const inStock = Number(control?.value) || 0;
    const qty = Number(this.products[index].qty) || 0;

    if (inStock > qty) {
      this.products[index].error = this.cs.getLabel('lbl_quantity_exceed_msg');
    } else {
      this.products[index].error = null;
    }

    this.products[index].inStock = inStock;
    this.products[index].remaining = qty - inStock;

    // Update dispatch date validation based on remaining quantity
    if (this.isOrderSplit) {
      const dispatchDateControl = formArray.at(index).get('dispatchDate');
      if (this.products[index].remaining === 0) {
        // Remove required validator when remaining quantity is 0
        dispatchDateControl?.clearValidators();
        dispatchDateControl?.setValue(null); // Clear the value since it's not needed
      } else {
        // Add required validator when remaining quantity > 0
        dispatchDateControl?.setValidators([Validators.required]);
      }
      dispatchDateControl?.updateValueAndValidity();
    }
  }

  buildProductFormArray() {
    const formArray = this.partialOrderForm.get('availableProductQty') as FormArray;
    formArray.clear();

    this.products.forEach((product, index) => {
      // Initialize inStock and remaining properties
      product.inStock = 0;
      product.remaining = Number(product.qty) || 0;

      const formGroup: any = {
        inStock: [
          '0',
          [
            this.numericRequiredValidator(),
            this.stockNotExceedQtyValidator((i) => Number(this.products[i].qty), index)
          ]
        ]
      };

      if (this.isOrderSplit) {
        // Initially, all quantity is remaining (since inStock starts at 0), so dispatch date is required
        formGroup.dispatchDate = ['', Validators.required];
      }

      formArray.push(this.fb.group(formGroup));
    });
  }

  numericRequiredValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === '' || isNaN(value)) {
        return { required: true };
      }
      return null;
    };
  }

  stockNotExceedQtyValidator(getQtyFn: (index: number) => number, index: number): ValidatorFn {
    return (control: AbstractControl) => {
      const inStock = Number(control.value);
      const qty = getQtyFn(index);

      if (isNaN(inStock) || inStock === null) return null;

      if (inStock > qty) {
        return { exceedQty: true };
      }

      if (inStock > 999999) {
        return { maxLimitExceeded: true };
      }

      return null;
    };
  }

  onConfirmQtyChange(product: any) {
    const qty = +product.qty;
    let confirmQty = +product.confirmQty || 0;

    if (isNaN(confirmQty) || confirmQty < 0) {
      confirmQty = 0;
    }

    if (confirmQty > qty) {
      product.confirmQty = qty;
      product.returnQty = 0;
    } else {
      product.confirmQty = confirmQty;
      product.returnQty = qty - confirmQty;
    }
  }

  onReturnQtyChange(product: any) {
    const qty = +product.qty;
    const totalReturnQty = (product.returnBatches || []).reduce((sum, batch) => {
      return sum + (+batch.returnQty || 0);
    }, 0);
    const clampedReturnQty = Math.min(totalReturnQty, qty);
    if (product.confirmBatches && product.confirmBatches.length > 0) {
      product.confirmBatches[0].confirmQty = qty - clampedReturnQty;
    }
    (product.returnBatches || []).forEach(batch => {
      this.clearReturnQtyError(batch);
    });
  }




  onConfirmRejectOrder() {
    this.rejectOrderForm.markAllAsTouched();
    if (!this.rejectOrderForm.valid) {
      return;
    }
    this.showRejectOrderDialogBox = false;
    if (this.rejectOrderForm.valid) {
      const reason = this.rejectOrderForm.get('reason')?.value;
      const payload = this.initEntityPayload("ORDER_REJECTED", this.orderId, '', reason, '');

      this.entityService.statusOrder(payload, false).subscribe(() => {
        this.messageService.add({
          key: 'tst',
          severity: 'success',
          summary: 'Success',
          detail: this.cs.getLabel('order.lbl_reject_order')
        });
        this.showRejectOrderDialogBox = false;
        this.getOrderDetails();
      })
    }
  }

  onCancelFullOrder() {
    this.showFullOrderDialogBox = false;
    this.fullOrderForm.reset();
    this.isFirstTimeDialogOpen = false;

    // Revert any edited tempUnitCost values back to original unitCost
    if (Array.isArray(this.products)) {
      this.products.forEach(product => {
        product.tempUnitCost = product.unitCost;
      });
    }
  }

  onCancelPartialOrder() {
    this.showPartialOrderDialogBox = false;
    this.partialOrderForm.reset();
    this.isFirstTimePartialDialogOpen = false;
    this.isOrderSplit = false;

    // Revert any edited tempUnitCost values back to original unitCost
    if (Array.isArray(this.products)) {
      this.products.forEach(product => {
        product.tempUnitCost = product.unitCost;
      });
    }
  }

  onCancelRejectOrder() {
    this.showRejectOrderDialogBox = false;
    this.rejectOrderForm.reset();
  }

  onClickReturn(product) {
    product.showReturn = true;
    product.confirmQty = product.qty;
    product.returnQty = 0;
    this.isProductReturned = this.deliveryProducts.some(ele => ele.returnBatches.length > 0);
  }

  onClearReturnProduct(product) {
    product.returnQty = 0;
    product.returnBatch = '';
    product.returnExpDate = '';
    product.showReturn = false;
    product.confirmQty = product.qty;
    product.confirmBatch = '';
    product.confirmExpDate = '';
    this.isProductReturned = this.deliveryProducts.some(ele => ele.returnBatches.length > 0);
  }

  onClearConfirmRow(product) {
    product.confirmQty = product.qty;
    product.confirmBatch = '';
    product.confirmExpDate = '';
    product.returnQty = 0;
  }

  showConfirmOrder() {
    const validationResult = this.isRequiredFieldError(this.deliveryProducts);
    if (validationResult.isError) {
      // Handle validation error - could show error message
    } else {
      this.showConfirmOrderDialog = true;
      this.isConfirmOrderInProgress = false;
    }
  }

  showConfirmOrderAndReturn() {
    this.returnOrderSummary[0].returning = 0;
    const isQtyIssue = this.deliveryProducts.some(ele => {
      const totalConfirmQty = (ele.confirmBatches || []).reduce((sum, batch) => sum + (+batch.confirmQty || 0), 0);
      const totalReturnQty = (ele.returnBatches || []).reduce((sum, batch) => sum + (+batch.returnQty || 0), 0);
      const totalQty = totalConfirmQty + totalReturnQty;
      return ele.qty !== totalQty;
    });
    if (isQtyIssue) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: this.cs.getLabel('order.error_confirmed_returned_quantity_issue') });
    } else {
      const validationResult = this.isRequiredFieldError(this.deliveryProducts);
      if (validationResult.isError) {
        // Handle validation error - could show error message
      } else {
        this.deliveryProducts.forEach(() => {
          // if (ele.showReturn) {
          this.returnOrderSummary[0].returning += 1;
          // }
        })
        this.setDialogFormView();
        this.showReturnOrderDialog = true;
        this.isConfirmOrderInProgress = false;
      }
    }
  }

  isRequiredFieldError(products) {
    let isError = false;
    const missingFields = [];

    products.forEach((product, productIndex) => {
      product.confirmBatches.forEach((batch, batchIndex) => {
        if (+batch.confirmQty > 0) {
          batch.confirmExpDateError = !batch.confirmExpDate;
          batch.confirmBatchError = !batch.confirmBatch;

          if (!batch.confirmExpDate || !batch.confirmBatch) {
            const missingConfirmFields = [];
            if (!batch.confirmExpDate) {
              missingConfirmFields.push('Expiry Date');
            }
            if (!batch.confirmBatch) {
              missingConfirmFields.push('Batch Number');
            }
            if (missingConfirmFields.length > 0) {
              missingFields.push(`${missingConfirmFields.join(', ')} for Product ${productIndex + 1}, Batch ${batchIndex + 1}`);
              isError = true;
            }
          } else {
            batch.confirmExpDateError = false;
            batch.confirmBatchError = false;
          }
        } else {
          batch.confirmExpDateError = false;
          batch.confirmBatchError = false;
        }
      });

      product.returnBatches.forEach((batch, batchIndex) => {
        const isReturnQtyEmpty = batch.returnQty === null || batch.returnQty === undefined || batch.returnQty === '';

        if (isReturnQtyEmpty) {
          batch.returnQtyError = false;
          batch.returnExpDateError = false;
          batch.returnBatchError = false;
          batch.returnReasonTypeError = false;
          batch.returnReasonError = false;
          return;
        }

        if (+batch.returnQty < 1) {
          batch.returnQtyError = true;
          isError = true;
          return;
        }

        batch.returnQtyError = false;
        batch.returnExpDateError = !batch.returnExpDate;
        batch.returnBatchError = !batch.returnBatch;
        batch.returnReasonTypeError = !batch.returnReasonType;
        batch.returnReasonError = batch.returnReasonType === 'OTHER' && (!batch.returnReason || !batch.returnReason.trim());

        if (!batch.returnExpDate || !batch.returnBatch || !batch.returnReasonType || (batch.returnReasonType === 'OTHER' && (!batch.returnReason || !batch.returnReason.trim()))) {
          const missingReturnFields = [];
          if (!batch.returnExpDate) {
            missingReturnFields.push('Return Expiry Date');
          }
          if (!batch.returnBatch) {
            missingReturnFields.push('Return Batch Number');
          }
          if (!batch.returnReasonType) {
            missingReturnFields.push('Return Reason Type');
          }
          if (batch.returnReasonType === 'OTHER' && (!batch.returnReason || !batch.returnReason.trim())) {
            missingReturnFields.push('Return Reason');
          }
          if (missingReturnFields.length > 0) {
            missingFields.push(`${missingReturnFields.join(', ')} for Product ${productIndex + 1}, Batch ${batchIndex + 1}`);
            isError = true;
          }
        } else {
          batch.returnExpDateError = false;
          batch.returnBatchError = false;
          batch.returnReasonTypeError = false;
          batch.returnReasonError = false;
        }
      });
    });

    return { isError, missingFields };
  }

  confirmOrder() {
    if (this.isConfirmOrderInProgress) {
      return;
    }

    this.isConfirmOrderInProgress = true;
    const requestBody = {
      forTenantCode: this.configService.getForTenantCode(),
      orderId: this.orderId,
      confirmOrderDto: this.getConfirmOrderDto(this.deliveryProducts)
    }
    this.entityService.acceptSiteOrder(AppSettings.ENTITY_CODE.ORDER, requestBody, true).subscribe({
      next: () => {
        this.showConfirmOrderDialog = false;
        this.getOrderDetails();
        this.messageService.add({
          key: 'tst',
          severity: 'success',
          summary: 'Success',
          detail: this.cs.getLabel('order.msg_order_confirmed_successfully')
        });
        this.isConfirmOrderInProgress = false;
      },
      error: () => {
        this.isConfirmOrderInProgress = false;
      }
    });
  }

  confirmOrderReturn(data) {
    if (this.isConfirmOrderInProgress) {
      return;
    }

    this.isConfirmOrderInProgress = true;
    const requestBody = {
      forTenantCode: this.configService.getForTenantCode(),
      orderId: this.orderId,
      confirmOrderDto: this.getConfirmOrderDto(this.deliveryProducts),
      proofImage: data.return_proof,
      returnReason: data.rejection_reason_type === 'OTHER' ? data.return_reason : data.rejection_reason_type,
      returnReasonType: data.rejection_reason_type
    }
    this.entityService.acceptSiteOrder(AppSettings.ENTITY_CODE.ORDER, requestBody, true).subscribe({
      next: () => {
        this.showReturnOrderDialog = false;
        this.getOrderDetails();
        this.messageService.add({
          key: 'tst',
          severity: 'success',
          summary: 'Success',
          detail: this.cs.getLabel('order.msg_order_return_confirmed_successfully')
        });
        this.isConfirmOrderInProgress = false;
      },
      error: () => {
        this.isConfirmOrderInProgress = false;
      }
    });
  }

  getConfirmOrderDto(products) {
    const productPayload = [];
    products.forEach(ele => {
      if (ele.confirmBatches && Array.isArray(ele.confirmBatches)) {
        ele.confirmBatches.forEach(batch => {
          if (+batch.confirmQty > 0) {
            productPayload.push({
              orderProductId: ele.productId,
              quantity: +batch.confirmQty,
              batchNumber: batch.confirmBatch,
              expiry: batch.confirmExpDate ? formatDate(batch.confirmExpDate, 'dd/MM/yyyy', 'en-US') : null,
              orderStatus: 'Accept'
            });
          }
        });
        ele.returnBatches.forEach(batch => {
          if (+batch.returnQty > 0) {
            productPayload.push({
              orderProductId: ele.productId,
              quantity: +batch.returnQty,
              batchNumber: batch.returnBatch,
              expiry: batch.returnExpDate ? formatDate(batch.returnExpDate, 'dd/MM/yyyy', 'en-US') : null,
              orderStatus: 'Return',
              returnReason: batch.returnReason,
              returnReasonType: batch.returnReasonType
            });
          }
        });

      }
    });
    productPayload.reverse();
    return productPayload;
  }

  getPartialDate() {
    this.entityService.getAttributeDefinition(AppSettings.ENTITY_CODE.ORDER, AppSettings.VIEW_CODE.DATE_OF_DISPATCH_VIEW).subscribe(res => {
      this.attributeIdOfDate = res.tabs[0].groups[0].fields.find(element => element.attributeCode === 'date_of_dispatch')?.attributeId;
    });
  }

  confirmDateChange(selectedDate: Date) {
    const selectedTimestamp = selectedDate.getTime();
    this.partialDateData.languageCode = this.language?.[0]?.langCode || 'en';
    this.partialDateData.data = [
      {
        attributeId: this.attributeIdOfDate,
        attributeValue: selectedTimestamp
      }
    ];

    this.entityService.saveAttributeData(this.partialDateData.entityCode, this.orderId, this.partialDateData).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Date Changed',
          detail: this.cs.getLabel('lbl_dispatch_date_msg')
        });
        this.getOrderDetails();
      },
    });
  }

  setDialogFormView() {
    this.dialogAttrLabels = this.cs.getAttributeLabels(this.labelData) as unknown as Record<string, string>;
    this.confirmAttributeData = {
      tabs: [
        {
          groups: [
            {
              fields: [
                {
                  attributeCode: 'return_proof',
                  attributeValue: null,
                  uiColumns: 12,
                  inputCode: 'fileImgPdf',
                  fieldName: 'return_proof',
                  validation: { required: true }
                }
              ]
            }
          ]
        }
      ]
    };
  }

  getTotalQuantity(): number {
    if (!this.deliveryProducts || this.deliveryProducts.length === 0) {
      return 0;
    }
    return this.deliveryProducts.reduce((total, product) => total + (product.qty || 0), 0);
  }

  getTotalReturningQuantity(): number {
    if (!this.deliveryProducts || this.deliveryProducts.length === 0) {
      return 0;
    }
    return this.deliveryProducts.reduce((total, product) => {
      if (product.returnQty) {
        return total + (product.returnQty || 0);
      } else if (product.returnBatches) {
        return total + (product.returnBatches.reduce((sum, batch) => sum + (+batch.returnQty || 0), 0) || 0);
      }
      return total;
    }, 0);
  }



  getDeleted(): boolean {
    return this.orderDetails?.actionStatus === 'DELETED';
  }

  getUnassigned(): boolean {
    return this.orderDetails?.actionStatus === 'UNASSIGNED';
  }



  setupForDeliveryConfirmation() {
    this.deliveryProducts = this.products.map(ele => ({
      ...ele,
      confirmBatches: [
        {
          confirmQty: ele.qty,
          confirmBatch: '',
          confirmExpDate: '',
          returnQty: 0,
          returnBatch: '',
          returnExpDate: '',
          showReturn: false,
        }
      ],
      returnBatches: []
    }));
  }

  removeBatch(product: any, batchIndex: number) {
    if (product.confirmBatches && product.confirmBatches.length > 1) {
      product.confirmBatches.splice(batchIndex, 1);
    }
  }

  onRemoveReturnBatch(product: any, batchIndex: number) {
    if (product.returnBatches && product.returnBatches.length > 0) {
      product.returnBatches.splice(batchIndex, 1);
      this.isProductReturned = this.deliveryProducts.some(ele => ele.returnBatches.length > 0);
      this.onReturnQtyChange(product);
    }
  }

  clearConfirmBatchError(batch: any) {
    if (batch.confirmBatch && batch.confirmBatch.trim()) {
      if (batch.confirmBatch.length >= 20) {
        batch.confirmBatchError = true;
        batch.confirmBatchMaxLengthError = true;
      } else {
        batch.confirmBatchError = false;
        batch.confirmBatchMaxLengthError = false;
      }
    } else if (!batch.confirmBatch || !batch.confirmBatch.trim()) {
      batch.confirmBatchError = true;
      batch.confirmBatchMaxLengthError = false;
    }
  }

  clearConfirmExpDateError(batch: any) {
    if (batch.confirmExpDate) {
      batch.confirmExpDateError = false;
    } else {
      batch.confirmExpDateError = true;
    }
  }

  clearReturnQtyError(batch: any) {
    const isEmpty = batch.returnQty === null || batch.returnQty === undefined || batch.returnQty === '';
    batch.returnQtyError = !isEmpty && +batch.returnQty < 1;
    if (isEmpty) {
      batch.returnBatchError = false;
      batch.returnBatchMaxLengthError = false;
      batch.returnExpDateError = false;
      batch.returnReasonTypeError = false;
      batch.returnReasonError = false;
      batch.returnReasonMaxLengthError = false;
    }
  }

  clearReturnBatchError(batch: any) {
    if (batch.returnQty === null || batch.returnQty === undefined || batch.returnQty === '') {
      batch.returnBatchError = false;
      batch.returnBatchMaxLengthError = false;
      return;
    }
    if (batch.returnBatch && batch.returnBatch.trim()) {
      if (batch.returnBatch.length > 20) {
        batch.returnBatchError = true;
        batch.returnBatchMaxLengthError = true;
      } else {
        batch.returnBatchError = false;
        batch.returnBatchMaxLengthError = false;
      }
    } else if (!batch.returnBatch || !batch.returnBatch.trim()) {
      batch.returnBatchError = true;
      batch.returnBatchMaxLengthError = false;
    }
  }

  clearReturnExpDateError(batch: any) {
    if (batch.returnQty === null || batch.returnQty === undefined || batch.returnQty === '') {
      batch.returnExpDateError = false;
      return;
    }
    if (batch.returnExpDate) {
      batch.returnExpDateError = false;
    } else {
      batch.returnExpDateError = true;
    }
  }

  clearReturnReasonTypeError(batch: any) {
    if (batch.returnQty === null || batch.returnQty === undefined || batch.returnQty === '') {
      batch.returnReasonTypeError = false;
      return;
    }
    if (batch.returnReasonType) {
      batch.returnReasonTypeError = false;
      if (batch.returnReasonType === 'OTHER') {
        this.clearReturnReasonError(batch);
      }
    } else {
      batch.returnReasonTypeError = true;
    }
  }

  clearReturnReasonError(batch: any) {
    if (batch.returnQty === null || batch.returnQty === undefined || batch.returnQty === '') {
      batch.returnReasonError = false;
      batch.returnReasonMaxLengthError = false;
      return;
    }
    if (batch.returnReason && batch.returnReason.trim()) {
      if (batch.returnReason.length > 500) {
        batch.returnReasonError = true;
        batch.returnReasonMaxLengthError = true;
      } else {
        batch.returnReasonError = false;
        batch.returnReasonMaxLengthError = false;
      }
    } else if (!batch.returnReason || !batch.returnReason.trim()) {
      batch.returnReasonError = true;
      batch.returnReasonMaxLengthError = false;
    }
  }

  openPatientDialog(patientCodes: string[]) {
    this.selectedPatientCodes = patientCodes;
    this.showPatientDialog = true;
  }

  closePatientDialog() {
    this.showPatientDialog = false;
    this.selectedPatientCodes = [];
  }

  onSplitOrder() {
    this.isOrderSplit = true;
    this.buildProductFormArray();

    const remainingProductControl = this.partialOrderForm.get('dispatchDateRemainingProduct');
    if (remainingProductControl) {
      remainingProductControl.clearValidators();
      remainingProductControl.setValue(null);
      remainingProductControl.updateValueAndValidity();
    }
  }

  onRemoveSplitOrder() {
    this.isOrderSplit = false;
    this.buildProductFormArray();

    const remainingProductControl = this.partialOrderForm.get('dispatchDateRemainingProduct');
    if (remainingProductControl) {
      remainingProductControl.setValidators(Validators.required);
      remainingProductControl.updateValueAndValidity();
    }

    const formArray = this.partialOrderForm.get('availableProductQty') as FormArray;
    formArray.controls.forEach(control => {
      const dispatchDateControl = control.get('dispatchDate');
      if (dispatchDateControl) {
        dispatchDateControl.setValue(null);
        dispatchDateControl.clearValidators();
        dispatchDateControl.updateValueAndValidity();
      }
    });
  }

  onConfirmOrderDialogHide() {
    this.showConfirmOrderDialog = false;
    this.isConfirmOrderInProgress = false;
  }

  onReturnOrderDialogHide() {
    this.showReturnOrderDialog = false;
    this.isConfirmOrderInProgress = false;
  }
}

